import { DataGridColumnDefinition, DataGridColumnDefinitionWithCustomCellFormatter } from "../../../../../widget";
import { AvatarCellFormatter } from "../../../../../widget/data/DataGrid/components/CellFormatters";

export class LandholdingDashboardConstants {
  public static readonly getProjectsCoumns = (hasPartialAccess: boolean): DataGridColumnDefinition[] => {
    return hasPartialAccess
      ? [
          {
            name: "Project",
            key: "link",
            dataType: "string",
            formatter: "link",
            minWidth: 216,
          },
          {
            name: "Phase",
            key: "cachedPhase",
            dataType: "string",
            formatter: "projectPhasePill",
            minWidth: 216,
          },
          {
            name: "Project type",
            key: "projectType.displayName",
            formatter: "stringWithEllipsis",
            dataType: "string",
            minWidth: 216,
          },
          {
            name: "Developer",
            key: "developer.displayName",
            formatter: "stringWithEllipsis",
            dataType: "string",
            minWidth: 176,
          },
          {
            name: "Units",
            key: "cachedUnitTotal",
            dataType: "number",
            filterable: true,
            sortable: true,
            minWidth: 112,
          },
          {
            name: "Area (ha)",
            key: "areaNetHa",
            dataType: "number",
            filterable: true,
            sortable: true,
          },
          {
            name: "Access",
            key: "access",
            dataType: "string",
            filterable: false,
            sortable: false,
          },
          {
            name: "Notes",
            key: "notesButton",
            dataType: "string",
            formatter: "icon",
            alignment: "center",
            filterable: false,
            sortable: false,
            minWidth: 66,
          },
        ]
      : [
          {
            name: "Project",
            key: "link",
            dataType: "string",
            formatter: "link",
            minWidth: 216,
          },
          {
            name: "Phase",
            key: "cachedPhase",
            dataType: "string",
            formatter: "projectPhasePill",
            minWidth: 216,
          },
          {
            name: "Project type",
            key: "projectType.displayName",
            formatter: "stringWithEllipsis",
            dataType: "string",
            minWidth: 216,
          },
          {
            name: "Developer",
            key: "developer.displayName",
            formatter: "stringWithEllipsis",
            dataType: "string",
            minWidth: 176,
          },
          {
            name: "Units",
            key: "cachedUnitTotal",
            dataType: "number",
            filterable: true,
            sortable: true,
            minWidth: 112,
          },
          {
            name: "Area (ha)",
            key: "areaNetHa",
            dataType: "number",
            filterable: true,
            sortable: true,
          },
        ];
  };

  public static readonly UPCOMING_TASKS_COLUMNS: (
    | DataGridColumnDefinition
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    | DataGridColumnDefinitionWithCustomCellFormatter<any>
  )[] = [
    {
      name: "Task",
      key: "taskLink",
      dataType: "string",
      formatter: "buttonLink",
      alignment: "left",
      filterable: true,
      minWidth: 340,
      sortable: true,
    },
    {
      key: "projectLink",
      name: "Project",
      dataType: "string",
      formatter: "link",
      alignment: "left",
      filterable: true,
      minWidth: 140,
      sortable: true,
    },
    {
      name: "Assigned to",
      key: "avatar",
      dataType: "string",
      formatter: "custom",
      alignment: "center",
      customCellFormatter: AvatarCellFormatter,
      filterable: true,
      minWidth: 70,
      sortable: true,
    },
    {
      key: "deadlineDate",
      name: "Deadline",
      dataType: "Date",
      formatter: "dateOnlyWithIndicator",
      alignment: "left",
      minWidth: 100,
    },
    {
      key: "viewTasksBoardIcon",
      name: "Tasks board",
      dataType: "string",
      formatter: "iconLink",
      alignment: "center",
      filterable: false,
      sortable: false,
      minWidth: 70,
    },
  ];
}
